// Error codes the staff sign-in endpoints answer with, shared by the Better Auth
// gate that throws them and the sign-in page that maps them to copy (BUG-2104).

/**
 * The email proved its inbox (the sign-in code was correct) but has no staff
 * account and no valid invite. Admin is invite-only.
 */
export const NO_STAFF_ACCESS_CODE = 'NO_STAFF_ACCESS' as const;

/** The message the server sends with {@link NO_STAFF_ACCESS_CODE}. */
export const NO_STAFF_ACCESS_MESSAGE =
  'This email does not have access to Auctogon. Ask your administrator for an invite.';

/**
 * The `?error=` Better Auth appends to a Google sign-in's `errorCallbackURL`
 * when the invite gate (`gateStaffUserCreate`) refuses to create the staff
 * user: the Google email has no staff account and no valid invite (BUG-2162).
 */
export const SOCIAL_CREATE_DENIED_CODE = 'unable_to_create_user' as const;

/**
 * Accept-invite's words for that refusal: the Google or Apple account chosen is
 * not the one the invitation was sent to (BL-2776: provider-neutral).
 */
export const INVITE_SOCIAL_MISMATCH_MESSAGE =
  'This account does not match the invitation. Continue with the account for the invited email.';

/**
 * The `?error=` Better Auth appends to a Google sign-in's `errorCallbackURL`
 * when the Google email matches a staff account whose own email is not verified:
 * account linking (`STAFF_ACCOUNT_LINKING.requireLocalEmailVerified`) refuses it
 * and no session is created (BUG-2299).
 */
export const SOCIAL_ACCOUNT_NOT_LINKED_CODE = 'account_not_linked' as const;

/**
 * What the sign-in page and the phone app say for that refusal. An email-code
 * sign-in verifies the inbox, after which social sign-in works.
 */
export const EMAIL_NOT_VERIFIED_MESSAGE =
  'Your email is not verified yet. Sign in with an email code first, then social sign-in will work.';

/**
 * What the sign-in page says for any other `?error=` a social sign-in returns
 * (Better Auth's `invalid_code`, a provider's `access_denied`, …). Provider-neutral
 * because Google and Apple both return here, and it never names the cause: the
 * detail stays in the server log (BUG-2603).
 */
export const SOCIAL_SIGN_IN_FAILED_MESSAGE = 'Sign-in failed. Please try again.';
